var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination-container"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pageData.current,"page-sizes":[20, 30, 50, 100],"page-size":_vm.pageData.size,"layout":"prev, pager, next, sizes, jumper","total":_vm.total},on:{"current-change":_vm.handleCurrentChange,"size-change":_vm.handleSizeChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }